import { z } from "zod";

// Shared contract for list/table endpoints that support server-side search,
// pagination and per-column sorting. The API validates incoming query params
// against this schema; the portal's <DataTable> emits exactly these params.
//
// Backward compatibility: every list endpoint keeps returning its existing
// entity-keyed array (e.g. { schools: [...] }) and merely ADDS total/page/
// per_page. When a request carries none of these params the endpoint behaves
// exactly as before (full set, default order), so dropdown/picker consumers
// are unaffected.
export const listQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  per_page: z.coerce.number().int().min(1).max(100).optional(),
  search: z.string().trim().min(1).optional(),
  sort: z.string().optional(),
  order: z.enum(["asc", "desc"]).default("asc"),
});

export type ListQueryInput = z.infer<typeof listQuerySchema>;

// Pagination metadata returned alongside the entity array. per_page is null
// when the endpoint returned an unbounded set (no client paging requested on a
// reference-data endpoint).
export interface ListMeta {
  total: number;
  page: number;
  per_page: number | null;
}
